<fgb-facial-recognition-image-uploader
  [uploadedImage]="uploadedImage"
  [formData]="formData"
  [isUploadInfo]="isUploadInfo"
  [goToStep]="goToStep"
></fgb-facial-recognition-image-uploader>
